import { checkUserHasAdminRole, checkUserHasClientRole, checkUserHasManagerRole, checkUserHasMemberRole } from "app/services/app.state.service";
import { TeamMembersClientView } from "app/components/team-members/TeamMembersClientView";
import { TeamMembersAdminView } from "app/components/team-members/TeamMembersAdminView";
import { TeamMembersMemberView } from "app/components/team-members/TeamMembersMemberView";
import { TeamMembersManagerView } from "app/components/team-members/TeamMembersManagerView";

export const TeamMembersRouterFactory = () => {
    if(checkUserHasAdminRole()) {
        return <TeamMembersAdminView />
    }
    else if(checkUserHasManagerRole()) {
        return <TeamMembersManagerView />
    }
    else if(checkUserHasClientRole()) {
        return <TeamMembersClientView />
    }
    else if(checkUserHasMemberRole()) {
        return <TeamMembersMemberView />
    }
    else {
        window.location.href = "/login";
    }
}